import { ChartData } from "chart.js";
import { useMemo, useRef } from "react";
import { IDashboardTrendChart } from "../../../models/dashboard";
import generateRandomColor from "../../../utils/randomColor";

type Labels = string[]

interface Result {
    ref: React.MutableRefObject<null>
    data: ChartData<"line", number[], string>
}

export function useLineChart (labels?: Labels, datasets?: IDashboardTrendChart['dataSets']): Result {
    const ref = useRef(null)
    
    return useMemo(() => {
        if (datasets && labels) {
            const dataset = datasets.map(i => {
                const color = generateRandomColor()
                return {
                    ...i,
                    borderColor: color,
                    backgroundColor: color,
                    tension: .4,
                }
            })
    
            return {
                data: {
                    labels,
                    datasets: dataset as any,
                },
                ref: ref
            }
        }
        
        return {
            data: {
                labels: [],
                datasets: [],
            },
            ref: ref
        }
    }, [labels, datasets, ref])
}
